@if (triggerType() === 'button') {
  <button
    [cdkMenuTriggerFor]="buttonOptionsTemplate"
    class="mdw-button mdw-secondary"
    [icon]="icons.Time_Duotone"
  >
    <p class="pad-left-050" [class.secondary]="timeValue().length === 0">{{ timeValue() }}</p>
  </button>
  <ng-template #buttonOptionsTemplate>
    <ng-container *ngTemplateOutlet="optionsTemplate"></ng-container>
  </ng-template>
} @else {
  <button
    [cdkMenuTriggerFor]="inputOptionsTemplate"
    type="button"
    class="mdw-time-trigger relative fill-width hflex-100 flex-align-items-center flex-justify-content-space-between"
  >
    <div class="hflex-100 flex-align-items-center">
      <mdw-icon class="clock-icon small-icon" [icon]="icons.Time_Duotone"></mdw-icon>
      <p>{{ timeValue() }}</p>
    </div>
    <mdw-icon class="dropdown-icon small-icon chevron" [icon]="icons.DropdownArrow"></mdw-icon>
  </button>

  <ng-template #inputOptionsTemplate>
    <ng-container *ngTemplateOutlet="optionsTemplate"></ng-container>
  </ng-template>
}

<ng-template #optionsTemplate>
  <menu
    class="surface-elevated border-radius-100 pad-300"
    cdkMenu
    animate.enter="menu-enter"
    animate.leave="menu-leave"
  >
    <mdw-time-input [value]="value()" (valueChange)="value.set($event)"></mdw-time-input>
  </menu>
</ng-template>
